import React, { useState } from 'react';    
import { useNavigate, Link } from 'react-router-dom';
import classes from "./2-YourDetails.module.css";  
import classes2 from "../components/yourdetails/CalculateButton.module.css"
import FancyToggle from "../components/results/switches/FancyToggle"
      
function ConsentPage() {      
  const navigate = useNavigate();  
  const [isChecked, setIsChecked] = useState(false);  
  const [button_clicked, set_button_clicked] = useState(false)    
  
  const navigateToInputForm = () => { 
    set_button_clicked(true)
    if(isChecked) {
      navigate('/yourdetails'); 
    }     
         
  }  
  
  const handleCheckboxChange = () => {   
    setIsChecked(!isChecked);  
  }  
      
  return (      
    <div>      
      <h2>Extra information and declaration</h2>      
      <p>      
        <b>This tool won’t check your information against other systems. Your data won't be shared or stored. </b>
      </p>
      <p>
        This tool is for guidance to help you understand how your total pension benefits are affected by your remedy choice. 
        The figures are based on the information you put in, so they won’t be the same as those in your Annual Benefit Statement. 
      </p>      
      <p>      
        <b>The figures aren’t your final retirement benefit offer and can’t be used as financial advice. You’ll receive a letter with accurate figures to help you make your choice when you apply for your pension benefits. </b>
      </p>
      <p>
      For many affected members, the remedy choice will be straightforward. 
      If you have more complex circumstances and you need support to decide 
      which option is right for you, please speak to an independent financial adviser. 
      You may be able to able to apply to have the cost of this advice repaid to you through the <a href="https://www.nhsbsa.nhs.uk/public-service-pensions-remedy-mccloud/nhs-cost-claim-back-scheme"  target = "_blank">Cost Claim Back Scheme</a>. 
      </p>  
      <p>
        If you’d like to speak to an independent financial adviser (IFA),
         make sure you find one who is informed about the NHS Pension Scheme.
          We can’t recommend any individual providers but <a href = "https://www.nhsemployers.org/publications/access-pension-tax-guidance-and-advice" target = '_blank'> NHS Employers </a> 
          have created a list of organisations that can give guidance and 
          advice on pension tax issues for NHS Pension Scheme members.
      </p>    
      <p> <b>The illustrator uses figures based on the following assumptions:   </b></p>      
      <table>     
        <tbody> 
        <tr>      
          <td>Inflation</td>      
          <td>Actual CPI used up to today’s date, 2% per year for future projections </td>      
        </tr>      
        <tr>      
          <td>General pay increases</td>      
          <td>2% per year</td>      
        </tr>  
        </tbody>     
      </table>      
      <p>      
      This illustrator is designed to reflect the value of pension benefits at retirement in pounds sterling (£).
       This means they have not been adjusted for future inflation and so do not represent benefits in “today's money”.    
      </p>
      <p>
      Inflation is the rate at which prices increase over time. To give you an idea of the value of your pension benefits at retirement, 
      we have applied actual rates of inflation based on the Consumer Price Index (CPI) up to today’s date. As we don’t know what inflation will be in the future, 
      we have assumed a standard rate of inflation of 2% each year from today’s date on. This means the actual value in today’s terms would be lower than the figures shown 
      in the illustrator. 
      </p>
      <p>
        There are some things not covered by this illustrator, like Scheme Pays arrangements and what your decision means for your tax position. The majority of members are not 
        likely to see a change to their tax position, but you can check using HMRC’s dedicated PSPR guidance and calculator 
        at <a href="https://www.gov.uk/guidance/calculate-your-public-service-pension-adjustment" target = '_blank'>https://www.gov.uk/guidance/calculate-your-public-service-pension-adjustment.</a> 
      </p>
      <p>
        You can see a full list of exclusions for this illustrator 
        on the <a href="https://www.nhsbsa.nhs.uk/public-service-pensions-remedy-mccloud/making-your-decision-about-your-nhs-pension-benefits" target = "_blank"> Choice on Retirement</a> webpage.
      </p>
      <h2>Declaration</h2>
      <p>By using this illustrator, you agree that you have read, understood, and agree to the Terms & Conditions set out in the 
        <Link to = "/T&Cs"> T&Cs' tab</Link>
        .
      </p>       
      <div className = {classes2.fancy_toggle_container}> 
      <FancyToggle state = {isChecked} handleChange = {handleCheckboxChange} showInflationSwitch = {true} active_colour = 'var(--deep-blue)'/>    
      <p style = {{'color' : isChecked ? 'black' : 'grey', 'fontWeight' : isChecked ? '700' :'600'}}>I have read, understand, and agree to the terms of service.</p>
      </div>
      <br/>      
        
      <div className={classes.button_container}>  
        <button className={classes2.pagebutton} onClick={navigateToInputForm}>  
          Continue to the Pension Illustration Tool  
        </button>  
        
      </div>   
      {!isChecked && button_clicked && <p className = {classes2.warning_message}> You must agree to the terms of service before you can proceed</p>}
    </div>      
  );      
}     
    
export default ConsentPage;  
